import {
  AdviceProductDetailsFormValues,
  Education,
  WorkSituation,
} from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";

import { mapHasEmployerPaidDisabilityInsurance } from "Store/akaAdvice/mappers/utils";

export const getWorkStatus = (
  workSituation: WorkSituation,
): string | undefined => {
  switch (workSituation) {
    case WorkSituation.WORK_PRIVATE:
    case WorkSituation.WORK_PUBLIC:
      return "Employed";
    case WorkSituation.SELF_EMPLOYED:
      return "SelfEmployed";
    case WorkSituation.FULL_TIME_STUDENT:
      return "FullTimeStudent";
    case WorkSituation.SICK_LEAVE:
      return "SickLeave";
    case WorkSituation.UNEMPLOYED:
      return "Unemployed";
    case WorkSituation.NOT_WORKING:
    default:
      return undefined;
  }
};

export const getEducation = (
  education: Education | undefined,
): string | undefined => {
  switch (education) {
    case Education.HIGH_SCHOOL_PLUS_5_YEARS:
      return "highSchoolPlus5Years";
    case Education.HIGH_SCHOOL_PLUS_3_YEARS:
      return "highSchoolPlus3Years";
    case Education.HIGH_SCHOOL:
      return "highSchool";
    case Education.NOT_HIGH_SCHOOL:
      return "notHighSchool";
    default:
      return undefined;
  }
};

export const mapFormToDisabilityPriceRequest = (
  formValues: AdviceProductDetailsFormValues,
): Record<string, any> => ({
  education: getEducation(formValues.education),
  hasEmployerPaidDisabilityInsurance:
    mapHasEmployerPaidDisabilityInsurance(formValues),
  coverageAmountCapital: null,
  paymentAfter3Months: false,
  workStatus: getWorkStatus(formValues.workSituation),
  yearlyIncome: formValues.income,
});
